import React, { useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import CinemaIcon from "../cinema/CinemaIcon";
import localizationStrings from "../../statics/localization";
import NewVodDetail from "./NewVodDetail";

export default function VodDetailModal({ onClose, background }) {
  const { vodId } = useParams();
  const history = useHistory();
  const scrollRef = useRef(null);
  const dialogRef = useRef(null);
  const closeRef = useRef(null);
  const closeAction = useRef(onClose);
  closeAction.current = onClose;

  useEffect(() => {
    const opener = document.activeElement;
    const x = window.scrollX,
      y = window.scrollY;
    const style = document.body.style;
    const previous = {};
    [
      "position",
      "top",
      "left",
      "right",
      "width",
      "overflow",
      "paddingRight"
    ].forEach((key) => {
      previous[key] = style[key];
    });
    const gutter = window.innerWidth - document.documentElement.clientWidth;
    style.position = "fixed";
    style.top = `-${y}px`;
    style.left = "0";
    style.right = "0";
    style.width = "100%";
    style.overflow = "hidden";
    if (gutter > 0) style.paddingRight = `${gutter}px`;
    document.body.classList.add("atlas-vod-modal-open");
    if (closeRef.current) closeRef.current.focus({ preventScroll: true });

    const onKeyDown = (event) => {
      const dialog = dialogRef.current;
      if (!dialog || event.defaultPrevented) return;
      // Playback, purchase and confirmation overlays own their keyboard input.
      const notification = document.querySelector(
        "#notification_root .notification-container"
      );
      const nested =
        (notification && notification.getClientRects().length
          ? notification
          : null) ||
        Array.from(
          dialog.querySelectorAll(
            '.modal-root, .notification-container, [aria-modal="true"]'
          )
        )
          .filter((el) => el.getClientRects().length)
          .pop();
      if (event.key === "Escape" && !event.defaultPrevented && !nested) {
        event.preventDefault();
        closeAction.current();
      }
      if (event.key !== "Tab") return;
      const scope = nested || dialog;
      const focusable = Array.from(
        scope.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'
        )
      ).filter(
        (el) =>
          el.getClientRects().length &&
          !el.closest('[inert], [aria-hidden="true"]')
      );
      const first = focusable[0],
        last = focusable[focusable.length - 1];
      if (!first) {
        event.preventDefault();
        scope.focus();
        return;
      }
      if (
        !scope.contains(document.activeElement) ||
        (event.shiftKey && document.activeElement === first)
      ) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      Object.keys(previous).forEach((key) => {
        style[key] = previous[key];
      });
      document.body.classList.remove("atlas-vod-modal-open");
      const returning =
        history.location.pathname === background.pathname &&
        history.location.search === background.search;
      window.scrollTo(returning ? x : 0, returning ? y : 0);
      if (returning && opener && opener.isConnected)
        opener.focus({ preventScroll: true });
    };
  }, []);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
    if (closeRef.current) closeRef.current.focus({ preventScroll: true });
  }, [vodId]);

  return (
    <div
      className="vod-detail-overlay"
      ref={scrollRef}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        className="vod-detail-modal"
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="vod-modal-title"
        tabIndex={-1}
      >
        <div className="vod-modal-toolbar">
          <button
            ref={closeRef}
            type="button"
            className="vod-modal-close"
            onClick={onClose}
            aria-label={localizationStrings.close || "Close"}
          >
            <CinemaIcon name="close" />
          </button>
        </div>
        <NewVodDetail key={vodId} scrollRef={scrollRef} />
      </section>
    </div>
  );
}
